var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Flex, TransparentButton, Trigger } from "../..";
import { CardHeaderContainer, CardHeaderTitle } from './';
export var ExpandableCardHeader = function (_a) {
    var title = _a.title, onClick = _a.onClick, _b = _a.isExpandable, isExpandable = _b === void 0 ? false : _b, _c = _a.isExpanded, isExpanded = _c === void 0 ? false : _c, _d = _a.trigger, TriggerComponent = _d === void 0 ? Trigger : _d, _e = _a.triggerPosition, triggerPosition = _e === void 0 ? 'left' : _e, _f = _a.triggerColor, triggerColor = _f === void 0 ? 'primary500' : _f, props = __rest(_a, ["title", "onClick", "isExpandable", "isExpanded", "trigger", "triggerPosition", "triggerColor"]);
    var handleClick = function (e) {
        if (typeof onClick === 'function') {
            onClick(e);
        }
    };
    return (React.createElement(TransparentButton, { type: "button", onClick: handleClick, lss: {
            width: '100%',
            p: 0,
            m: 0,
            borderRadius: 'inherit',
            display: 'flex',
            alignItems: 'center',
            ':focus': {
                outlineWidth: 1
            }
        }, "aria-expanded": isExpanded },
        React.createElement(CardHeaderContainer, __assign({}, props, { isExpanded: isExpanded, isExpandable: isExpandable, lss: __assign({ bg: 'gray100' }, props.lss) }),
            React.createElement(Flex, { lss: {
                    flex: '1 0 100%',
                    alignItems: 'center'
                } },
                isExpandable && TriggerComponent && triggerPosition === 'left' && (React.createElement(TriggerComponent, { isExpanded: isExpanded, isStatic: true, triggerColor: triggerColor })),
                title && React.createElement(CardHeaderTitle, { title: title, titleLss: props.titleLss }),
                isExpandable && TriggerComponent && triggerPosition === 'right' && (React.createElement(React.Fragment, null,
                    React.createElement(Flex, { lss: { flex: '1 0 auto' } }),
                    React.createElement(TriggerComponent, { isExpanded: isExpanded, isStatic: true, triggerColor: triggerColor })))))));
};
//# sourceMappingURL=ExpandableCardHeader.js.map